// @flow

import {Environment} from 'relay-runtime'
import {commitMutation, graphql} from 'react-relay'

const mutation = graphql`
    mutation StreamEditMutation(
    $input: StreamEditInput!
    ) {
        StreamEdit(input: $input) {
            stream {
                id
            }
        }
    }
`;

export function commit(environment: Environment, params: any, callback: (error: ?Error, location: ?string) => void) {
    console.log(`edit`);
    commitMutation(
        environment,
        {
            mutation: mutation,
            variables: {
                input: params
            },
            onCompleted: (response) => {
                if (response.error !== null && response.error !== undefined) {
                    callback(response.error, null);
                    return
                }
                
                callback(null, response)
            },
            onError: (error) => {
                console.log("error mutating");
                console.log(error);
                callback(error, null);
            },
        })
}


// WEBPACK FOOTER //
// src/mutations/StreamEditMutation.js